// src/components/Header.js
import React from 'react';
import { AppBar, Toolbar, Typography, Button, Box, Menu, MenuItem, IconButton, Badge, TextField, Autocomplete, Paper, CircularProgress } from '@mui/material';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { handleLogout, getValidAccessToken } from '../utils/tokenUtils';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import NotificationIconWithDropdown from './notifications';
import SearchIcon from '@mui/icons-material/Search';
import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL;

const Header = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const username = localStorage.getItem('user_name');
    const [NotificationAnchorEl, setNotificationAnchorEl] = React.useState(null);
    const [searchOptions, setSearchOptions] = React.useState([]);
    const [searchLoading, setSearchLoading] = React.useState(false);
    const [searchValue, setSearchValue] = React.useState('');
    const [inputValue, setInputValue] = React.useState('');

    // Open the menu
    const handleMenuClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    // Close the menu
    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleNotificationClick = (event) => {
        setNotificationAnchorEl(event.currentTarget);
    };
    const handleNotificationClose = () => {
        setNotificationAnchorEl(null);
    }

    // Handle global search
    const handleSearchChange = async (event, value, reason) => {
        setInputValue(value);
        
        if (!value || value.length < 2) {
            setSearchOptions([]);
            return;
        }

        setSearchLoading(true);
        try {
            const token = await getValidAccessToken();
            
            // Single unified API call for global search
            const response = await axios.get(`${apiUrl}/search/?q=${encodeURIComponent(value)}`, {
                headers: { 'Authorization': `Bearer ${token}` }
            }).catch(() => ({ data: { results: [] } }));

            // Format results from unified API
            const results = response.data.results || [];
            setSearchOptions(results);
        } catch (error) {
            console.error('Search error:', error);
            setSearchOptions([]);
        } finally {
            setSearchLoading(false);
        }
    };

    const handleSearchSelect = (event, option) => {
        if (option) {
            if (option.type === 'ticket') {
                navigate(`/ticket-data?ticket_id=${option.id}`);
            } else if (option.type === 'user') {
                navigate(`/user/${option.username}`);
            }
            setInputValue('');
            setSearchOptions([]);
        }
    };

    return (
        <AppBar position="fixed" sx={{ backgroundColor: 'secondary.main' }}>
            <Toolbar>
                {/* Add the logo image */}
                <Box sx={{ mr: 2 }}>
                    <img
                        src={`${process.env.PUBLIC_URL}/log3.png`}
                        alt="SaveTax LLC Logo"
                        style={{ height: '50px', width: 'auto' }}
                    />
                </Box>
                <Typography variant="h6" sx={{ flexGrow: 1, color: '#ff4700' }}>
                    
                </Typography>

                <Box>
                    {location.pathname === '/signup' ? (
                         <>
                            <Button color="inherit" component={Link} to="/">
                                Home
                            </Button>
                            
                            <Button color="inherit" component={Link} to="/signup">
                                Signup
                            </Button>
                            <Button color="inherit" component={Link} to="/login">
                                Login
                            </Button>
                        </>
                    ) : location.pathname === '/login' ? (
                         <>
                            <Button color="inherit" component={Link} to="/">
                                Home
                            </Button>
                            
                            <Button color="inherit" component={Link} to="/signup">
                                Signup
                            </Button>
                            <Button color="inherit" component={Link} to="/login">
                                Login
                            </Button>
                        </>
                    ) :
                        <Box style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                         <Box sx={{ mr: 3, width: '300px' }}>
                        <Autocomplete
                            freeSolo
                            options={searchOptions}
                            loading={searchLoading}
                            inputValue={inputValue}
                            onInputChange={handleSearchChange}
                            onChange={handleSearchSelect}
                            getOptionLabel={(option) => {
                                if (typeof option === 'string') return option;
                                return option.label || '';
                            }}
                            groupBy={(option) => option.type === 'ticket' ? 'Tickets' : 'Users'}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    placeholder="Search tickets, users..."
                                    size="small"
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            color: 'white',
                                            '& fieldset': {
                                                borderColor: 'rgba(255,255,255,0.5)',
                                            },
                                            '&:hover fieldset': {
                                                borderColor: 'rgba(255,255,255,0.8)',
                                            },
                                        },
                                        '& .MuiOutlinedInput-input::placeholder': {
                                            color: 'rgba(255,255,255,0.7)',
                                            opacity: 1,
                                        },
                                    }}
                                    InputProps={{
                                        ...params.InputProps,
                                        startAdornment: (
                                            <SearchIcon sx={{ mr: 1, color: 'rgba(255,255,255,0.7)' }} />
                                        ),
                                        endAdornment: (
                                            <>
                                                {searchLoading ? <CircularProgress color="inherit" size={20} /> : null}
                                                {params.InputProps.endAdornment}
                                            </>
                                        ),
                                    }}
                                />
                            )}
                            renderOption={(props, option) => (
                                <MenuItem
                                    {...props}
                                    sx={{
                                        py: 1,
                                        px: 2,
                                        '&:hover': {
                                            backgroundColor: 'rgba(255, 71, 0, 0.1)',
                                        }
                                    }}
                                >
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                        {option.type === 'ticket' ? (
                                            <Box sx={{ fontSize: '0.9em', fontWeight: 'bold' }}>🎫</Box>
                                        ) : (
                                            <Box sx={{ fontSize: '0.9em', fontWeight: 'bold' }}>👤</Box>
                                        )}
                                        <Typography variant="body2">{option.label}</Typography>
                                    </Box>
                                </MenuItem>
                            )}
                            noOptionsText="No results found"
                        />
                    </Box>
                        <NotificationIconWithDropdown />
                        <Menu anchorEl={NotificationAnchorEl} open={Boolean(NotificationAnchorEl)} onClose={handleNotificationClose}>
                            <MenuItem onClick={handleMenuClose}>Notification 1</MenuItem>
                            <MenuItem onClick={handleMenuClose}>Notification 2</MenuItem>
                            <MenuItem onClick={handleMenuClose}>Notification 3</MenuItem>
                        </Menu>
                        <Button color="inherit" component={Link} to="/refer-and-earn">
                                Refer & Earn
                            </Button>
                            <Button color="inherit" component={Link} to="/profile">
                                Profile
                            </Button>
                           {/* Welcome Button */}
                           <Button
                                color="inherit"
                                onClick={handleMenuClick}
                            >
                                Welcome, {username}
                            </Button>
                            <Menu
                                anchorEl={anchorEl}
                                open={Boolean(anchorEl)}
                                onClose={handleMenuClose}
                            >
                                <MenuItem onClick={handleLogout}>Logout</MenuItem>
                            </Menu>
                        </Box>
                    }
                </Box>
            </Toolbar>
        </AppBar>
    );
};

export default Header;
